import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const CibleIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '60%' : '100%'}
      height={circled ? '60%' : '100%'}
      viewBox="0 0 29.027 29.027"
    >
      <g transform="translate(1 1.027)">
        <path
          d="M342.2,192.345l-3.7,3.7V201l5.7-5.719-.005-2.1A1.17,1.17,0,0,0,342.2,192.345Z"
          transform="translate(-320.468 -192)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M338.5,201l5.7-5.719,2.1.005a1.174,1.174,0,0,1,.825,2L343.432,201Z"
          transform="translate(-320.468 -192)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M341.684,201a11.561,11.561,0,1,1-3.186-3.221"
          transform="translate(-320.468 -192)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M336.973,207.4a4.938,4.938,0,1,1-4.938-4.952A4.945,4.945,0,0,1,336.973,207.4Z"
          transform="translate(-320.468 -192)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="10.386"
          y2="10.417"
          transform="translate(11.477 5.152)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
